@if (person() && formVisibilities()) {
    <div class="content flex-column gap-large">
        <!-- gridster-item-content vyjímá interaktivní prvky z úchytu pro tažení karty -->
        <div class="top-panel flex align-items-center gap" [class.drag-handler]="movable()">
            <app-input-file-btn
                class="gridster-item-content"
                [owner]="'person_'+person().id" [replaceByOwner]="true"
                (uploaded)="onFileUpload($event)"
                [disabled]="!canEdit()"
            >
                <app-avatar
                    size="xxxlarge"
                    [initials]="person() | personInitials"
                    [src]="person().image"
                    [userSex]="person().sex"
                ></app-avatar>
            </app-input-file-btn>
            <app-link-button
                [disabled]="folderStore.isTerminated()"
                [label]="person() | formatPerson"
                class="name flex-1 gridster-item-content"
                (clickEvent)="goToEdit()"
            ></app-link-button>

            @if (folderPerson()) {
                <!-- klikem na hvězdičku se přepíná primární osoba složky -->
                <i
                    class="main-person-star text-danger"
                    [class]="(isMainPerson() ? 'pi pi-star-fill' : 'pi pi-star')
                        + (canToggleMain() ? ' clickable gridster-item-content' : '')"
                    [pTooltip]="mainPersonTooltip() | translate"
                    (click)="toggleMainPerson()"
                ></i>

                <app-folder-person-actions
                    class="person-actions gridster-item-content"
                    [folderPerson]="folderPerson()!"
                    [serviceId]="folder().serviceId"
                    [disabled]="folderStore.isTerminated()"
                    (folderPersonChanged)="onFolderPersonChanged()"
                ></app-folder-person-actions>
            }

            <app-button class="settings-link gridster-item-content" icon="pi-cog" [rounded]="true" [text]="true"
                (clickEvent)="pbiSettings.toggle($event)"/>
            <p-popover #pbiSettings styleClass="settings-content-wrapper">
                <div class="settings-content flex-column justify-content-center gap-small">
                    @for (group of Object.entries(groupedFields()); track $index; let first = $first) {
                        @if (!isHealthCare() && group[1].length > 0) {
                            <div class="font-bold" [class.mt-2]="!first">
                                {{ 'person.basicInfo.tab.' + group[0] | translate }}
                            </div>
                        }

                        @for (property of group[1]; track $index) {
                            <div>
                                <app-check-input
                                    [label]="'person.basicInfo.' + property"
                                    [id]="property"
                                    [form]="formVisibilities()"
                                ></app-check-input>
                            </div>
                        }
                    }
                </div>
            </p-popover>
        </div>

        @if (isSocial()) {
            <p-tabs value="basicInfo">
                <p-tablist>
                    <p-tab value="basicInfo">{{ 'person.basicInfo.tab.basicInfo' | translate }}</p-tab>
                    @if (isSocialCare()) {
                        <p-tab value="unpaid">{{ 'person.basicInfo.tab.unpaid' | translate }}</p-tab>
                    }
                    <p-tab value="statistics">{{ 'person.basicInfo.tab.statistics' | translate }}</p-tab>
                </p-tablist>

                <p-tabpanels>
                    <p-tabpanel value="basicInfo">
                        <ng-container *ngTemplateOutlet="basicInfoContent"></ng-container>
                    </p-tabpanel>

                    @if (isSocialCare()) {
                        <p-tabpanel value="unpaid">
                            <ng-container *ngTemplateOutlet="unpaidContent"></ng-container>
                        </p-tabpanel>
                    }

                    <p-tabpanel value="statistics">
                        <ng-container *ngTemplateOutlet="statisticsContent"></ng-container>
                    </p-tabpanel>
                </p-tabpanels>
            </p-tabs>
        } @else {
            <ng-container *ngTemplateOutlet="basicInfoContent"></ng-container>
        }

        <ng-template #basicInfoContent>
            <div class="info-grid">
                @if (formVisibilities()?.controls?.birthdate?.value) {
                    <span>{{ 'person.basicInfo.birthdate' | translate }}:</span>
                    <span class="font-bold">{{ person().birthdate | shortDate }}</span>
                }

                @if (isSocial()) {
                    @if (formVisibilities().controls.mobile?.value && person().mobile) {
                        <span>{{ 'person.basicInfo.mobile' | translate }}:</span>
                        <span class="font-bold">{{ person().mobile }}</span>
                    }

                    @if (formVisibilities().controls.phone?.value && person().phone) {
                        <span>{{ 'person.basicInfo.phone' | translate }}:</span>
                        <span class="font-bold">{{ person().phone }}</span>
                    }

                    @if (formVisibilities().controls.email?.value && person().email) {
                        <span>{{ 'person.basicInfo.email' | translate }}:</span>
                        <span class="font-bold">{{ person().email }}</span>
                    }

                    @if (formVisibilities().controls.communikePassword?.value && communikePassword) {
                        <span>{{ 'person.basicInfo.communikePassword' | translate }}:</span>
                        <div class="flex gap-small align-items-center">
                            <span class="font-bold">{{ displayedCommunikePassword }}</span>
                            <i
                                [class]="'font-size-small cursor-pointer ' + (showCommunikePassword ? 'pi pi-eye-slash' : 'pi pi-eye')"
                                (click)="toggleCommunikePassword()"
                            ></i>
                        </div>
                    }
                }

                @if (isHealthCare() || isNursingHome()) {
                    @if (formVisibilities()?.controls?.insuranceNumber?.value) {
                        <span>{{ 'person.basicInfo.insuranceNumber' | translate }}:</span>
                        <span class="font-bold">{{ person().insuranceNumber }}</span>
                    }
                }

                @if (formVisibilities()?.controls?.address?.value) {
                    <!-- adresa se vybírá pro celou složku, editovat ji lze jen z karty vlastníka -->
                    @if (canEdit() && !folderStore.isTerminated() && isFolderOwner()) {
                        <app-button
                            [label]="'person.basicInfo.address' | translate"
                            (clickEvent)="editAddress()"
                            [text]="true"
                            icon="pi-pencil"
                        ></app-button>
                    } @else {
                        <span>{{ 'person.basicInfo.address' | translate }}:</span>
                    }
                    <span>
                        <app-map-link
                            [format]="person().currentAddress?.address ? MapLinkFormatEnum.MultiLine : null"
                            tooltip="person.basicInfo.address"
                            [data]="person().currentAddress?.address || null"
                        ></app-map-link>
                    </span>
                }

                @if (formVisibilities().controls.contact?.value && person().phone) {
                    <span>{{ 'person.basicInfo.contact' | translate }}:</span>
                    <span class="font-bold">{{ person().phone }}</span>
                }

                @if (formVisibilities().controls.workplace.value) {
                    <span>{{ 'person.basicInfo.workplace' | translate }}:</span>

                    @if (store.hasMultipleWorkplaces()
                        && !store.currentWorkplace()?.workplaceDeleted
                        && !folderStore.isTerminated()
                        && canEdit()) {
                        <app-link-button
                            [label]="store.currentWorkplace()?.name?.length ? store.currentWorkplace()?.name || null : '-'"
                            (clickEvent)="openWorkplacesDialog()"
                        ></app-link-button>
                    } @else {
                        <div>{{ store.currentWorkplace()?.name?.length ? store.currentWorkplace()?.name : '-' }}</div>
                    }
                }

                @if (formVisibilities().controls.groups.value) {
                    <span>{{ 'person.basicInfo.groups' | translate }}:</span>

                    @if (folderStore.isTerminated() || !canEdit()) {
                        <div class="p-button-label text-left">
                            @if (generalGroups()) {
                                <span>{{ generalGroups() }}</span>
                            } @else {
                                <span>-</span>
                            }
                        </div>
                    } @else {
                        <app-link-button (clickEvent)="openGroupDialog(ServiceGroupEnum.GENERAL)">
                            <div class="p-button-label text-left">
                                @if (generalGroups()) {
                                    <span>{{ generalGroups() }}</span>
                                } @else {
                                    <span>-</span>
                                }
                            </div>
                        </app-link-button>
                    }
                }

                @if (store.creditInfo(); as creditInfo) {
                    <div>{{ 'socialCredits.dashboard.group' | translate }}:</div>
                    <div class="flex flex-wrap gap-small">
                        <div>{{ creditInfo.groupName || '-' }}</div>
                        <div class="font-bold">
                            ({{ 'socialCredits.dashboard.balance' | translate: {
                                amount: (creditInfo.balance | formatNumber: 2 : true)
                            } }})
                        </div>
                    </div>
                }

                @if (isSocial() && formVisibilities().controls.targetGroup.value) {
                    <span>{{ 'person.basicInfo.targetGroup' | translate }}:</span>

                    @if (folderStore.isTerminated() || !canEdit()) {
                        <div class="p-button-label text-left">
                            @if (targetGroups()) {
                                <span>{{ targetGroups() }}</span>
                            } @else {
                                <span>-</span>
                            }
                        </div>
                    } @else {
                        <app-link-button (clickEvent)="openGroupDialog(ServiceGroupEnum.SOCIAL_TARGET)">
                            <div class="p-button-label text-left">
                                @if (targetGroups()) {
                                    <span>{{ targetGroups() }}</span>
                                } @else {
                                    <span>-</span>
                                }
                            </div>
                        </app-link-button>
                    }
                }

                @if (isHealthCare()) {
                    @if (formVisibilities().controls.workgroup?.value) {
                        <span>{{ 'person.basicInfo.workgroup' | translate }}:</span>
                        @if (folderStore.isTerminated() || !canEdit()) {
                            <div class="p-button-label text-left">
                                @if (folder().workgroup) {
                                    <span>{{ folder().workgroup?.serviceWorkgroupName }}</span>
                                } @else {
                                    <span>-</span>
                                }
                            </div>
                        } @else {
                            <app-link-button (clickEvent)="openWorkgroupDialog()">
                                <div class="p-button-label text-left">
                                    @if (folder().workgroup) {
                                        <span>{{ folder().workgroup?.serviceWorkgroupName }}</span>
                                    } @else {
                                        <span>-</span>
                                    }
                                </div>
                            </app-link-button>
                        }
                    }
                }

                @if (isSocial()) {
                    @if (formVisibilities().controls.keyWorker?.value) {
                        <span>{{ 'person.basicInfo.keyWorker' | translate }}:</span>
                        <div>
                            @if (folderStore.isTerminated() || !canEdit()) {
                                <div class="p-button-label text-left">
                                    @if (folder().keyWorker) {
                                        <span>{{ folder()?.keyWorker | formatPerson }}</span>
                                    } @else {
                                        <span>-</span>
                                    }
                                </div>
                            } @else {
                                <app-link-button (clickEvent)="openKeyWorkerDialog()">
                                    <div class="p-button-label text-left">
                                        @if (folder().keyWorker) {
                                            <span>{{ folder()?.keyWorker | formatPerson }}</span>
                                        } @else {
                                            <span>-</span>
                                        }
                                    </div>
                                </app-link-button>
                            }
                        </div>
                    }

                    @if (formVisibilities().controls.primaryContact?.value) {
                        <span>{{ 'person.basicInfo.primaryContact' | translate }}:</span>
                        <div>
                            @for (phone of primaryContactPhones(); track $index) {
                                <a href="tel:{{ phone }}" class="p-button-link">{{ phone }}</a>

                                @if (!$last) {
                                    <br>
                                }
                            }
                        </div>
                    }

                    @if (store.data.getPersonRestrictions()?.items?.[0] && formVisibilities().controls.personRestriction?.value) {
                        <span>{{ 'person.basicInfo.limitedLegalCapacity' | translate }}</span>
                        <div>{{ 'yes' | translate }}</div>
                    }

                    @if (formVisibilities().controls.dependence?.value) {
                        <span>{{ 'person.dependence.title' | translate }}</span>

                        @if (folderStore.isTerminated() || !canEdit()) {
                            <div class="p-button-label text-left">
                                <span>
                                    {{ dependenceText() }}
                                </span>
                            </div>
                        } @else {
                            <app-link-button (clickEvent)="openDependenceDialog()">
                                <div class="p-button-label text-left">
                                    <span>
                                        {{ dependenceText() }}
                                    </span>
                                </div>
                            </app-link-button>
                        }
                    }

                    @if (formVisibilities().controls.carePayment?.value) {
                        <span>{{ 'person.basicInfo.carePayment' | translate }}</span>
                        @if (folderStore.isTerminated() || !canEdit()) {
                            <div class="p-button-label text-left">
                                <span>
                                    {{ activeCarePayment() }}
                                </span>
                            </div>
                        } @else {
                            <app-link-button (clickEvent)="openCarePaymentDialog()">
                                <div class="p-button-label text-left">
                                    <span>
                                        {{ activeCarePayment() }}
                                    </span>
                                </div>
                            </app-link-button>
                        }
                    }

                    @if (billingEnabled()) {
                        <span>{{ 'person.basicInfo.useDownPayment' | translate }}</span>
                        @if (folderStore.isTerminated() || !canEditFolder()) {
                            <span>{{ 'common.trueFalseEnum.' + folder().useDownPayment | translate }}</span>
                        } @else {
                            <app-check-input
                                id="useDownPayment"
                                [form]="folderBillingForm"
                                [showLabel]="false"
                                (selectedValueChange)="updateFolderBillingSettings($event)"
                            ></app-check-input>
                        }
                    }

                    @if (formVisibilities().controls.serviceForm?.value && !store.currentServiceContractSettings().useCard) {
                        <span>{{ 'person.basicInfo.serviceForm' | translate }}</span>
                        <div class="p-button-label text-left">
                                <span>
                                    {{ serviceForm() }}
                                </span>
                        </div>
                    }
                }

                @if (showFolderPersonStay() && formVisibilities().controls.folderPersonStay?.value) {
                    <span>
                        {{ 'folder.persons.stay.label' | translate }}:
                    </span>
                    <!-- klikem se otevře historie všech pobytů osoby ve složce -->
                    <app-link-button
                        class="gridster-item-content"
                        [pTooltip]="'folder.persons.stay.showHistory' | translate"
                        (clickEvent)="openStayHistoryDialog()"
                    >
                        <div class="p-button-label text-left font-bold">{{ stayText() }}</div>
                    </app-link-button>
                }

            </div>
        </ng-template>

        <ng-template #unpaidContent>
            <div class="flex-column gap-small checkbox-container">
                @if (formVisibilities().controls.familyWithTriplets?.value) {
                    <app-check-input
                        [form]="formSocial()"
                        id="familyWithTriplets"
                        label="person.basicInfo.familyWithTriplets"
                    ></app-check-input>
                }

                @if (formVisibilities().controls.resistanceFighter?.value) {
                    <app-check-input
                        [form]="formSocial()"
                        id="resistanceFighter"
                        label="person.basicInfo.resistanceFighter"
                    ></app-check-input>
                }

                @if (formVisibilities().controls.rehabilitationPerson?.value) {
                    <app-check-input
                        [form]="formSocial()"
                        id="rehabilitationPerson"
                        label="person.basicInfo.rehabilitationPerson"
                    ></app-check-input>
                }

                @if (formVisibilities().controls.personFromLaborCamp?.value) {
                    <app-check-input
                        [form]="formSocial()"
                        id="personFromLaborCamp"
                        label="person.basicInfo.personFromLaborCamp"
                    ></app-check-input>
                }

                @if (formVisibilities().controls.spouseOfResistanceFighterOver70?.value) {
                    <app-check-input
                        [form]="formSocial()"
                        id="spouseOfResistanceFighterOver70"
                        label="person.basicInfo.spouseOfResistanceFighterOver70"
                    ></app-check-input>
                }

                @if (formVisibilities().controls.spouseOfRehabilitationPersonOver70?.value) {
                    <app-check-input
                        [form]="formSocial()"
                        id="spouseOfRehabilitationPersonOver70"
                        label="person.basicInfo.spouseOfRehabilitationPersonOver70"
                    ></app-check-input>
                }

                @if (formVisibilities().controls.spouseOfPersonFromLaborCampOver70?.value) {
                    <app-check-input
                        [form]="formSocial()"
                        id="spouseOfPersonFromLaborCampOver70"
                        label="person.basicInfo.spouseOfPersonFromLaborCampOver70"
                    ></app-check-input>
                }

                @if (formVisibilities().controls.livingInSecialPurposeApartment?.value) {
                    <app-check-input
                        [form]="formSocial()"
                        id="livingInSecialPurposeApartment"
                        label="person.basicInfo.livingInSecialPurposeApartment"
                    ></app-check-input>
                }
            </div>
        </ng-template>

        <ng-template #statisticsContent>
            <div class="info-grid checkbox-container">
                @if (formVisibilities().controls.residenceBeforeStartOfServiceProvision?.value) {
                    <span>{{ 'person.basicInfo.residenceBeforeStartOfServiceProvision' | translate }}</span>
                    <div class="mb-2">
                        <app-address-input
                            [form]="formSocial()"
                            id="residenceBeforeStartOfServiceProvision"
                        ></app-address-input>
                    </div>
                }

                @if (formVisibilities().controls.overindebtedClient?.value) {
                    <div class="fr-2">
                        <app-check-input
                            [form]="formSocial()"
                            id="overindebtedClient"
                            label="person.basicInfo.overindebtedClient"
                        ></app-check-input>
                    </div>
                }

                @if (formVisibilities().controls.clientHasPermanentResidenceInService?.value) {
                    <div class="fr-2">
                        <app-check-input
                            [form]="formSocial()"
                            id="clientHasPermanentResidenceInService"
                            label="person.basicInfo.clientHasPermanentResidenceInService"
                        ></app-check-input>
                    </div>
                }

                @if (formVisibilities().controls.clientHadResidenceAbroad?.value) {
                    <div class="fr-2">
                        <app-check-input
                            [form]="formSocial()"
                            id="clientHadResidenceAbroad"
                            label="person.basicInfo.clientHadResidenceAbroad"
                        ></app-check-input>
                    </div>
                }

                @if (formVisibilities().controls.permanentlyBedridden?.value) {
                    <div class="fr-2">
                        <app-check-input
                            [form]="formSocial()"
                            id="permanentlyBedridden"
                            label="person.basicInfo.permanentlyBedridden"
                        ></app-check-input>
                    </div>
                }

                @if (formVisibilities().controls.clientIsMobileWithHelp?.value) {
                    <div class="fr-2">
                        <app-check-input
                            [form]="formSocial()"
                            id="clientIsMobileWithHelp"
                            label="person.basicInfo.clientIsMobileWithHelp"
                        ></app-check-input>
                    </div>
                }

                @if (formVisibilities().controls.healthCareIsProvided?.value) {
                    <div class="fr-2">
                        <app-check-input
                            [form]="formSocial()"
                            id="healthCareIsProvided"
                            label="person.basicInfo.healthCareIsProvided"
                        ></app-check-input>
                    </div>
                }
            </div>
        </ng-template>
    </div>
}
